module.exports = __webpack_public_path__ + "img/Menu-11.c2237d35.png";